import request from '@/utils/request'

export function getCertData(query) {
    return request({
        url: '/cert/cert_data',
        method: 'get',
        params: query
    })
}

export function updateCertData(data){
    return request({
        url: '/cert/cert_data',
        method: 'post',
        data
    })
}

export function updateRelation(data){
    return request({
        url: '/file/files',
        method: 'put',
        data
    })
}